import { render, staticRenderFns } from "./ModulosModalEdicion.vue?vue&type=template&id=1d3289b8&scoped=true&"
import script from "./ModulosModalEdicion.vue?vue&type=script&lang=ts&"
export * from "./ModulosModalEdicion.vue?vue&type=script&lang=ts&"
import style0 from "./ModulosModalEdicion.vue?vue&type=style&index=0&id=1d3289b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3289b8",
  null
  
)

export default component.exports